// istanbul ignore file
export default function getLocalTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
